import React, {ReactNode} from 'react';
import Page, {PageType} from '@episerver/spa-core/Page';
import CellcomGeneralPageData from '../../Models/Content/CellcomGeneralPageData';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {compareCurrentTimeToRange} from '../../utilities/dateUtils';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../Config';
import './StandardPage.scss';

export default class CellcomGeneralPage extends Page<CellcomGeneralPageData> {
  protected pageType = PageType.Other;

  public render(): ReactNode {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }

    const currentTimeIsValid = compareCurrentTimeToRange(this.props.data.pageStartTime?.value, this.props.data.pageEndTime?.value);
    if (!currentTimeIsValid) {
      EpiContext.navigateTo(this.props.data.timeRangeExceededPageReference?.value);
      return null;
    }
    console.log('[CellcomGeneralPage] render');
    return <ContentArea context={this.getContext()} data={this.props.data.mainContentArea} propertyName='mainContentArea' />;
  }
}
